import { render, staticRenderFns } from "./OpenGraph.vue?vue&type=template&id=239528a6"
import script from "./OpenGraph.vue?vue&type=script&lang=js"
export * from "./OpenGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports